<template>
  <!-- 林长通古树 -->
  <div ref="discussBox" id="discussBox" class="lztComment">
    <div
      class="list-content"
      id="list-content"
      :class="['list-content', 'cotentPd']"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
      >
        <div class="list-item">
          <van-cell v-for="item in commentlists" :key="item.id" class="item">
            <div class="critic">
              <dl class="criticInfo">
                <dt class="criticImg">
                  <img
                    :src="
                      item.avatar ? item.avatar : baseUrl + 'userDefault.png'
                    "
                    alt
                  />
                </dt>
                <dd class="criticName">
                  {{ item.userName }}
                  <span class="criticTime">{{
                    item.createTime ? item.createTime : ""
                  }}</span>
                </dd>
                <dd class="criticmain">
                  <p
                    class="evauateList"
                    v-if="item.evaluateList && item.evaluateList[0]"
                  >
                    <span
                      v-for="(evaItem, index) in getChangeEvaluateList(
                        item.evaluateList
                      )"
                      :key="index"
                      :style="{
                        color: evaItem.fontColor,
                        background: evaItem.bgColor,
                      }"
                    >
                      {{ evaItem.name }}
                    </span>
                  </p>
                  <p class="content">{{ item.content }}</p>
                  <div v-if="item.imgList != null">
                    <div
                      class="imgWrap dis_flex"
                      v-if="item.imgList.length != 4"
                    >
                      <div
                        class="img"
                        v-for="(itemImg, imgIndex) in item.imgList"
                        :key="'dfff' + itemImg + item.id + imgIndex"
                        @click="seeImg(item.imgList, index)"
                      >
                        <van-image fit="cover" :src="itemImg" />
                      </div>
                    </div>
                    <div class="imgWrap" v-else>
                      <div class="dis_flex">
                        <template v-for="(itemImg, imgIndex) in item.imgList">
                          <div
                            class="img"
                            :key="itemImg + item.id + imgIndex"
                            v-if="imgIndex == 0 || imgIndex == 1"
                            @click="seeImg(item.imgList, index)"
                          >
                            <van-image fit="cover" :src="itemImg" />
                          </div>
                        </template>
                      </div>
                      <div class="dis_flex">
                        <template v-for="(itemImg, imgIndex) in item.imgList">
                          <div
                            class="img"
                            :key="itemImg + item.id + imgIndex"
                            v-if="imgIndex == 2 || imgIndex == 3"
                            @click="seeImg(item.imgList, index)"
                          >
                            <van-image fit="cover" :src="itemImg" />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </dd>
              </dl>
            </div>
          </van-cell>
        </div>
      </van-list>
    </div>
    <div class="addCommentBox">
      <img
        :src="baseUrl + 'addCommontIcon.png'"
        alt
        srcset
        @click="addForestCommont"
      />
    </div>
    <!-- 增加评论弹出框 -->
    <van-popup
      v-model="addCommontPicker"
      round
      closeable
      @click-overlay="closeAddNote"
      @close="closeAddNote"
      close-icon="close"
      class="addJsPickerBox"
    >
      <p class="addTit">新增评论</p>
      <div class="addPage">
        <!-- 评价列表 -->
        <p class="fgx"></p>
        <van-cell-group class="baseNone beizhu">
          <van-field class="readonlyText" value="评价内容" required readonly />
          <van-field
            v-model="addcommontData.content"
            rows="3"
            autosize
            type="textarea"
            maxlength="500"
            placeholder="请输入评价内容"
            show-word-limit
          />
        </van-cell-group>
        <p class="fgx"></p>
        <div class="evaluateBox" v-if="evaluateList && evaluateList[0]">
          <van-checkbox-group v-model="selectEvaluate" ref="checkboxGroup">
            <van-row gutter="20" class="itemBox">
              <van-col
                v-for="item in evaluateList"
                :key="item.id"
                @click="addGoodNumber(item)"
                :class="['itemList', item.isChecked ? 'selectItem' : '']"
              >
                <van-checkbox :name="item.code">{{
                  item.dictName
                }}</van-checkbox>
              </van-col>
            </van-row>
          </van-checkbox-group>
        </div>
        <p class="fgx"></p>
        <div class="uploadBox">
          <van-field value="现场图片" readonly />
          <div class="clearfix uploadMian">
            <ul class="fl clearfix">
              <li
                v-for="(item, index) in addcommontData.imgList"
                :key="index"
                class="fl"
              >
                <div class="upload">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="item"
                    @click="seeImg(addcommontData.imgList, index)"
                  />
                  <van-icon
                    name="close"
                    @click="delImg(index)"
                    class="delImgBtn"
                  />
                </div>
              </li>
            </ul>
            <ul class="fl" v-if="addcommontData.imgList < 9">
              <li @click="addgetImgs">
                <div class="upload">
                  <i
                    class="
                      van-icon van-icon-photograph
                      van-uploader__upload-icon
                    "
                  ></i>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="btnBox">
          <van-button
            type="primary"
            :loading="btnLoading"
            loading-text="保存中..."
            @click="saveComment"
            class="btn"
            >提交</van-button
          >
        </div>
      </div>
    </van-popup>
    <!-- 放大图片组件 -->
    <van-image-preview
      v-model="magnifyImgShow"
      :images="magnifyImgList"
      class="magnifyImg"
      :start-position="magnifyImgListIndex"
    />
  </div>
</template>

<script>
/* eslint-disable */
import newApi from "lodash";
import group from "@/assets/images/group.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { getCurTime } from "@/utils/common";
export default {
  name: "comment",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      lon: "",
      lat: "",
      objid: "", //古树Id
      commentlists: [],
      backstagelists: [],
      NewArray: [],
      commentCount: 0,
      page: 0,
      pageSize: 10,
      contentHeight: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      group: group,
      //添加评论
      evaluateList: [], //评价列表
      addCommentBtnPicker: false,
      addCommontPicker: false, //新增评论弹框
      btnLoading: false,
      selectEvaluate: [], //选中的评价
      addcommontData: {
        content: "", //评论内容
        evaluateDic: [], //评价数组
        imgList: [], //评论图片
        treeId: "", //古树ID
      },
      commontAvatar: "",
      commontUserName: "",
      commontCreateTime: "",
      magnifyImgShow: false,
      magnifyImgList: [],
      magnifyImgListIndex: 0,
      clientType: getDeviceType(),
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  created() {
    this.treeId = this.$route.query.commonId;
  },

  mounted() {
    //获取经纬度
    this.lon = this.$route.query.lon;
    this.lat = this.$route.query.lat;
    window.setPoints = this.setPoints;
    window.setFile = this.setFiles;
    this.$nextTick(function () {
      if (this.treeId == undefined) {
        this.treeId = this.dataInfo.id;
      }
      this.$set(this.addcommontData, "treeId", this.treeId);
      this.getUserInfo();
      this.getTest();
      this.getEvaluateList();
    });
  },
  methods: {
    getUserInfo() {
      let _this = this;
      _this.$api.slbkOldTree
        .getLztToGsLogin()
        .then((res) => {
          if (res.code == "1") {
            _this.commontAvatar = res.data.avatar
              ? res.data.avatar
              : res.data.gender == "m"
              ? "https://dhome-lzz.oss-cn-hangzhou.aliyuncs.com/20200330/1a4a5dc76c3a43a3aa189bf1b09c16bb.png"
              : "https://dhome-lzz.oss-cn-hangzhou.aliyuncs.com/20200515/fm.png";

            _this.commontUserName = res.data.realName;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTest() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.slbkOldTree
        .guShuComment(_this.page, _this.pageSize, _this.treeId)
        .then((res) => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            _this.commentCount = res.data.total;
            _this.backstagelists = res.data.list;
            this.commentlists = this.commentlists.concat(_this.backstagelists);
            // 加载状态结束
            this.loading = false;
            if (_this.page * 10 >= total) {
              _this.finished = true;
              _this.reloadType = "";
              this.$emit("getType", _this.reloadType);
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },

    //转换评论列表==》评价列表数组
    getChangeEvaluateList(data) {
      let dataArr = [];
      data.forEach((item) => {
        let childArr = item.split("/");
        let objData = {
          name: childArr[0],
          bgColor: childArr[1],
          fontColor: childArr[2],
        };
        dataArr.push(objData);
      });
      return dataArr;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },
    imgError(item) {
      //图片地址失效
      item.headImgUrl = this.group;
    },

    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },

    closeBtn() {
      let state = false;
      this.$emit("propsHide", state); //点击事件触发后，自动触发swiperhide事件
    },
    seeImg(item, index) {
      console.log(item);
      let _this = this;

      _this.magnifyImgShow = true;
      _this.magnifyImgList = item;
      _this.magnifyImgListIndex = index;
    },
    roloadComment() {
      let _this = this;
      _this.commentCount = 0;
      _this.page = 0;
      _this.pageSize = 10;
      _this.loading = true; //是否处于加载状态
      _this.finished = false; //是否已加载完所有数据
      _this.isLoading = false; //是否处于下拉刷新状态
      _this.commentlists = [];
      this.getTest();
    },
    addForestCommont() {
      //显示评论框
      this.addCommontPicker = true;
    },
    getEvaluateList() {
      let _this = this;
      let lonlat = "point(" + _this.lon + " " + _this.lat + ")";
      _this.$api.slbkOldTree
        .treeEvaluateList({ id: _this.treeId, lonLat: lonlat })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.evaluateList = res.data;
            if (_this.evaluateList && _this.evaluateList[0]) {
              for (let i = 0; i < _this.evaluateList.length; i++) {
                _this.evaluateList[i].isChecked = false;
              }
            }
          } else {
            _this.evaluateList = [];
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addGoodNumber(item) {
      let _this = this;
      _this.$set(item, "isChecked", !item.isChecked);
    },
    //添加图片
    addgetImgs() {
      //添加图片方法
      let _this = this;
      if (_this.clientType == "android") {
        window.android.getInfo(102);
      } else {
        window.webkit.messageHandlers.getImgs.postMessage("1");
      }
    },
    setFiles(data) {
      //App回调添加上传文件
      console.log(data);
      if (this.clientType == "android") {
        this.setImgs(data);
      } else {
        this.setImgs(JSON.parse(data));
      }
    },
    setImgs(item) {
      //上传图片
      let _this = this;
      let arr = [];
      let imgsListArr = this.addcommontData.imgList;
      _this.$toast("图片上传成功！");
      arr.push(item.url);
      imgsListArr = imgsListArr.concat(arr);
      this.$set(this.addcommontData, "imgList", imgsListArr);
      // this.listData = this.listData.concat(arr);
    },
    closeAddNote() {
      this.$set(this.addcommontData, "content", "");
      this.$set(this.addcommontData, "imgList", []);
      this.$set(this.addcommontData, "evaluateDic", []);
      this.addCommontPicker = false;
    },
    delImg(index) {
      if (this.addcommontData.imgList != []) {
        this.$dialog
          .confirm({
            title: "提示",
            message: "是否确认删除图片",
          })
          .then(() => {
            let imgsList = this.addcommontData.imgList; //.splice(index, 1)
            imgsList.splice(index, 1);

            this.$set(this.addcommontData, "imgList", []);
            if (imgsList.length > 0) {
              this.$set(this.addcommontData, "imgList", imgsList);
            } else {
              this.$set(this.addcommontData, "imgList", []);
            }
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    saveComment() {
      let _this = this;
      if (_this.addcommontData.content == "") {
        _this.$toast("评论内容不能为空！");
      } else {
        if (_this.evaluateList && _this.evaluateList[0]) {
          _this.evaluateList.forEach((item) => {
            if (item.isChecked) {
              _this.addcommontData.evaluateDic.push(item.code);
            }
          });
        }
        _this.btnLoading = true;
        _this.$api.slbkOldTree
          .addGuShuComment(_this.addcommontData)
          .then((res) => {
            if (res.code == "1") {
              _this.$toast("发布成功！");
              _this.roloadComment();
              _this.addCommontPicker = false;
              _this.$set(_this.addcommontData, "content", "");
              _this.$set(_this.addcommontData, "evaluateDic", []);
              _this.$set(_this.addcommontData, "imgList", []);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
  },
};
</script>
<style lang="less">
.lztComment {
  width: 100%;
  height: 100%;
  font-family: "PingFangSC-Regular";
  color: #000;
  background-color: #fff;
  position: relative;

  .main {
    width: 95%;
    margin: 0 auto;
  }
  .fgf {
    width: 100%;
    height: 35px;
    background-color: #f6f6f6;
    font-size: 16px;
    font-family: "PingFangSC";
    font-weight: 400;
    color: #787878;
    line-height: 35px;
    padding-left: 20px;

    z-index: 999;
  }

  .list-content {
    height: 100%;
    overflow-y: scroll;
    background-color: #fff;

    .list-item {
      .item {
        margin-top: 17px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(235, 235, 235, 1);
        line-height: normal;

        .critic {
          position: relative;

          dl.criticInfo {
            position: relative;

            dt {
              position: absolute;
              top: 0;
              left: 0;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              -webkit-border-redius: 50%;
              -moz-border-redius: 50%;
              background-color: #d8d8d8;

              // background: #d8d8d8;
              img {
                display: block;
                width: 100%;
                height: 100%;
                border-radius: 50%;
                -webkit-border-redius: 50%;
                -moz-border-redius: 50%;
              }
            }

            .criticName {
              padding-left: 39px;
              width: 100%;
              font-size: 10px;
              color: #000;
              opacity: 0.5;
              margin-bottom: 10px;
            }

            .criticmain {
              display: inline-block;
              width: 100%;
              padding-left: 40px;
              // margin-left: 39px;
              // width: 255px;
              overflow: hidden;
              font-size: 13px;
              font-weight: 400;
              line-height: 18px;
              color: #000;
              .evauateList {
                span {
                  border-radius: 4px;
                  -webkit-border-redius: 4px;
                  -moz-border-redius: 4px;
                  display: inline-block;
                  padding: 4px 5px;
                  margin: 5px 5px;
                }
              }
              .content {
                margin-bottom: 10px;
              }
            }
          }
          .imgWrap {
            width: 100%;
            flex-wrap: wrap;

            .img {
              width: 33.33%;
              padding-right: 6px;
              padding-bottom: 6px;
              border-radius: 5px;
              -webkit-border-radius: 5px;
              -moz-border-radius: 5px;
              .van-image {
                width: 100%;
              }
              img {
                width: 100%;
                max-height: 75px;
                border-radius: 5px;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
              }
            }
          }
          .criticTime {
            display: inline-block;
            transform: scale(0.9);
            opacity: 0.3;
            color: #000;
          }

          .criticLike {
            position: absolute;
            top: 0;
            right: 0;

            span {
              display: block;
            }

            .criticLikeIcon {
              font-size: 15px;
              color: #000;
              text-align: center;
            }

            .criticCount {
              font-size: 10px;
              color: #000;
              text-align: center;
              margin-top: 0.05rem;
            }

            .red {
              color: #4bc08a;
            }
          }
        }
      }
    }
  }

  .list-content.cotentPd {
    padding-bottom: 60px;
  }

  .editor {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    min-height: 60px;
    padding: 8px 10px 8px;
    // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.7);
    background-color: #fff;

    .editorBtn {
      width: 90%;
      line-height: 14px;
      color: #333;
      font-size: 12px;
      text-align: left;
      margin-top: 5px;

      .van-cell {
        padding: 0;
      }

      .van-field {
        .van-cell__value {
          width: 100%;
          min-height: 35px;
          background-color: #f6f6f6;
          border-radius: 14px;
          -webkit-border-redius: 14px;
          -moz-border-redius: 14px;
          line-height: 17px;
        }

        .van-field__control {
          line-height: 35px !important;
          padding: 0 5px;
        }
      }
    }
  }
  .addCommentBox {
    width: 40px;
    height: 40px;
    position: fixed;
    bottom: 60px;
    right: 5px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    z-index: 999;
    background-color: #33bc6c;

    img {
      max-width: 100%;
    }
  }

  // 弹框信息
  /* .addJsPickerBox {
  ?

  .addJsPickerBox.van-popup--bottom.van-popup--round {
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
  }
  .imgWrap {
    width: 100%;
    flex-wrap: wrap;
    .img {
      width: 33.33%;
      padding-right: 6px;
      padding-bottom: 6px;
      img {
        width: 75px;
        height: 75px;
      }
    }
  }*/
}
// 弹框信息
.addJsPickerBox {
  width: 100%;
  height: 65%;
  padding-top: 50px;
  position: fixed !important;
  z-index: 9999 !important;

  .addTit {
    position: absolute;
    top: 0;
    width: 70%;
    height: 50px;
    line-height: 50px;
    left: 15%;
    text-align: center;
    font-size: 16px;
  }

  .van-icon {
    color: #333;
  }

  .addPage {
    width: 100%;
    height: calc(100% - 55px);
    overflow-y: scroll;
    background-color: #fff;
    .readonlyText.van-cell--required::before {
      left: 75px;
    }
    .evaluateBox {
      width: 100%;
      padding: 8px 16px 0;
      .itemBox {
        width: 100%;
        .itemList {
          position: relative;
          // padding: 0 20px !important;
          height: 30px;
          //border: 1px solid #f6f6f6;
          border-radius: 8px;
          -webkit-border-radius: 8px;
          -moz-border-radius: 8px;
          margin: 10px 8px;
          text-align: center;
          font-size: 14px;
          color: #333;
          background: #f6f6f6;
          .van-checkbox {
            height: 30px;

            .van-checkbox__icon {
              display: none;
            }

            .van-checkbox__label {
              margin: 0;
              line-height: 30px;
              color: inherit;
            }
          }
        }

        .itemList.selectItem {
          background-color: #36c177 !important;

          .van-checkbox__label {
            color: #fff;
          }
        }
      }
    }
  }

  .baseNone::after {
    content: none;
  }

  .baseNone.beizhu {
    min-height: 80px;
  }

  .uploadBox {
    padding: 0 16px 10px 16px;
    .van-cell {
      padding: 10px 0;
    }
    .van-cell:not(:last-child)::after {
      left: 0;
    }
    .uploadMian {
      margin-top: 8px;
    }
    .upload {
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      box-sizing: border-box;
      width: 65px;
      height: 65px;
      margin: 0 8px 8px 0;
      background-color: #f7f8fa;
      border-radius: 8px;

      .van-image {
        width: 65px;
        height: 65px;
      }

      .delImgBtn {
        font-size: 14px;
        color: red;
        position: absolute;
        top: -5px;
        right: -5px;
        z-index: 10001;
      }
    }
  }

  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;

    .btn.van-button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      height: 45px;
      span {
        line-height: 45px;
      }
    }
  }
  .fgx {
    width: 100%;
    height: 4px;
    background-color: #f4f4f4;
  }
}

.addJsPickerBox.van-popup--bottom.van-popup--round {
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
}
.forestTab.SmallTab .addJsPickerBox {
  width: 100%;
  height: 400px;
  padding-top: 50px;
  position: fixed !important;
  z-index: 9999 !important;
  bottom: 0;
  left: 0;
  top: auto;
  transform: none;
}
</style>
